import { Box } from "@mui/material";
import styles from "./style.module.css";
import Header from "./components/header";
import Filters from "./components/filter";
import GridResult from "./components/grid";
import ListResult from "./components/list";
import { useTheme } from "../../../context/themeContext";
import { useState } from "react";
import FiltersSelect from "./components/filters-modal";
import useProtectedAuth from "../../../hooks/useProtectedAuth";
import { useSelector } from "react-redux";
import useProjectFilters from "../../../hooks/useProjectFilters";

const JoinAProject = () => {
  useProtectedAuth();
  const { theme } = useTheme();
  const [tabOption, setTabOption] = useState("grid");
  const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false);
  const { results } = useSelector((state) => state.projectFilters);
  useProjectFilters();

  const clickGridOption = () => {
    setTabOption("grid");
  };

  const clickListOption = () => {
    setTabOption("list");
  };

  return (
    <Box
      className={styles.joinAProject}
      sx={{
        paddingBottom: "5rem",
        bgcolor: theme.palette.lightgrey.lightgrey500,
      }}
    >
      <Header
        clickGridOption={clickGridOption}
        clickListOption={clickListOption}
        tabOption={tabOption}
      />
      <Filters setIsModalOpen={setIsFiltersModalOpen} />
      <FiltersSelect
        isModalOpen={isFiltersModalOpen}
        setIsModalOpen={setIsFiltersModalOpen}
      />
      {tabOption === "grid" && <GridResult projects={results} />}
      {tabOption === "list" && <ListResult projects={results} />}
    </Box>
  );
};

export default JoinAProject;
